import React from 'react'

const RuleEngineIcon = () => {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 20V15C8 14.0667 7.85833 13.375 7.575 12.925C7.29167 12.475 6.91667 12.0333 6.45 11.6L7.875 10.175C8.075 10.3583 8.26667 10.554 8.45 10.762C8.63333 10.9707 8.81667 11.1917 9 11.425C9.23333 11.1083 9.471 10.829 9.713 10.587C9.95433 10.3457 10.2 10.1083 10.45 9.875C11.0833 9.29167 11.6583 8.61667 12.175 7.85C12.6917 7.08333 12.9667 5.74167 13 3.825L11.425 5.4L10 4L14 0L18 4L16.6 5.4L15 3.825C14.9667 6.20833 14.6 7.904 13.9 8.912C13.2 9.92067 12.5 10.7417 11.8 11.375C11.2667 11.8583 10.8333 12.329 10.5 12.787C10.1667 13.2457 10 13.9833 10 15V20H8ZM3.2 6.175C3.13333 5.84167 3.08733 5.475 3.062 5.075C3.03733 4.675 3.01667 4.25833 3 3.825L1.4 5.4L0 4L4 0L8 4L6.575 5.4L5 3.85C5 4.2 5.01667 4.52933 5.05 4.838C5.08333 5.146 5.11667 5.43333 5.15 5.7L3.2 6.175ZM5.35 10.575C5.01667 10.225 4.696 9.81667 4.388 9.35C4.07933 8.88333 3.80833 8.30833 3.575 7.625L5.5 7.15C5.66667 7.6 5.85833 7.98333 6.075 8.3C6.29167 8.61667 6.525 8.9 6.775 9.15L5.35 10.575Z"
        fill="white"
      />
    </svg>
  )
}

export default RuleEngineIcon
